import googlePlayImg from "../assests/google_play_official.png";
import appStoreImg from "../assests/app_store_official.svg";

/**
 * Official Google Play badge (PNG).
 * Default height: 52px — matches App Store badge visual height.
 */
export function GooglePlayBadge({ height = 52, className = "" }) {
  return (
    <img
      src={googlePlayImg}
      alt="Get it on Google Play"
      height={height}
      style={{ height, width: "auto", display: "block" }}
      className={className}
    />
  );
}

/**
 * Official Apple App Store badge (SVG).
 * Default height: 52px — matches Google Play badge visual height.
 */
export function AppStoreBadge({ height = 52, className = "" }) {
  return (
    <img
      src={appStoreImg}
      alt="Download on the App Store"
      height={height}
      style={{ height, width: "auto", display: "block" }}
      className={className}
    />
  );
}
